///////////////////
// Auto-generated
// Do not edit!!!
///////////////////
import {
    Component,
    OnInit,
    AfterViewInit,
    OnDestroy,
    Injector,
} from "@angular/core";
import { Observable } from "rxjs/Observable";
import { BehaviorSubject } from "rxjs/BehaviorSubject";
import { map } from "rxjs/operators/map";

import { State } from "@progress/kendo-data-query";

import { ModelDataResult } from "../../../core/data/model-data-result";
import { DataService } from "../../../core/data/data.service";

import { NotificationService } from "./../../../core/notification/notification.service";
import { Notification } from "./../../../core/notification/notification";

@Component({
    templateUrl: "./supplier-data-details.view.component.html",
    styleUrls: ["./supplier-data-details.view.component.css"],
})
export class SupplierDataDetailsViewBaseComponent
    implements OnInit, AfterViewInit, OnDestroy
{
    public $dataServices: { [key: string]: DataService<any> };
    public $dataServicesData: { [key: string]: Observable<any> };
    public $dataServicesResult: {
        [key: string]: BehaviorSubject<ModelDataResult<any>>;
    };
    public $notificationService: NotificationService;

    public $dataServicesState: { [key: string]: State } = {};

    public $dataModels: any = {};

    public $config: any = {
        components: {},
    };

    constructor(public injector: Injector) {
        this.$notificationService = this.injector.get(NotificationService);

        const dsConfig = this.getDataServicesConfig();
        this.$dataServices = {};

        this.$dataServicesData = {};

        this.$dataServicesResult = {};
    }

    public ngOnInit(): void {
        this["onInit"]();

        for (const dataSourceName of Object.keys(this.$dataServices)) {
            this.read(dataSourceName);
            this.dataServiceErrors(dataSourceName);
        }
    }

    public ngAfterViewInit(): void {
        this["onShow"]();
    }

    public ngOnDestroy(): void {
        this["onHide"]();
    }

    public read(dataSourceName): void {
        this.$dataServices[dataSourceName].read();
    }

    public getDataChanges(dataSourceName): Observable<any[]> {
        const dataService = this.$dataServices[dataSourceName];
        return dataService
            .dataChanges()
            .pipe(map((response) => (response ? response.data : [])));
    }

    public getDataResult(
        dataSourceName
    ): BehaviorSubject<ModelDataResult<any>> {
        return this.$dataServices[dataSourceName].dataChanges();
    }

    public dataServiceErrors(dataSourceName): void {
        this.$dataServices[dataSourceName].errors.subscribe((err: any) => {
            if (err) {
                const message = (err.error && err.error.message) || err.message;
                this.$notificationService.notify(
                    new Notification(
                        `<ul><li>${message}<li></ul>`,
                        "error",
                        10000
                    )
                );
            }
        });
    }

    protected getDataServicesConfig() {
        const config = {};

        return config;
    }
}



// WEBPACK FOOTER //
// C:/Repositories/wfa3/SupplierPortal/app/src/app/modules/group-booking/supplier-data-details/supplier-data-details.view.base.component.ts